import React, { useState } from 'react'
import { CreateTestDeckPopup } from '../../../../../components/create-test-deck-popup'
import ConfirmDialog from '../../../../../components/dialogs/confirm-dialog'
import { AdminManageGeneralChartState } from '../../hooks/use-admin-manage-general-chart'
import AdminManageGeneralChartControlButton from './admin-manage-general-chart-control-buttons'
import AdminManageGeneralChartGeneralData from './admin-manage-general-chart-general-data'
import AdminManageGeneralChartParties from './admin-manage-general-chart-parties'
import AdminManageGeneralChartRaces from './admin-manage-general-chart-races'

const AdminManageGeneralChartForm: React.FC<{
  state: AdminManageGeneralChartState
}> = ({ state }) => {
  const [errors, setErrors] = useState({})

  const watchCandidateNamesField = state.form.watch('showCandidateNames')

  return (
    <>
      <form
        className="container w-full mx-auto"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <AdminManageGeneralChartGeneralData
          state={state}
          candidatesNamesChecked={watchCandidateNamesField}
          setCandidatesNamesChecked={() =>
            state.form.setValue('showCandidateNames', !watchCandidateNamesField)
          }
        />
        <AdminManageGeneralChartParties state={state} />
        <AdminManageGeneralChartRaces
          candidatesNamesChecked={watchCandidateNamesField}
          state={state}
          handleErrors={setErrors}
          errors={errors}
        />
      </form>
      <AdminManageGeneralChartControlButton errors={errors} state={state} />
      <CreateTestDeckPopup
        chartId={state.chartId}
        open={state.showFileUpload}
        close={state.cancelFileUpload}
      />
      <ConfirmDialog
        isOpen={state.showAlreadyBallotFileDialog}
        title="Ballot File Found"
        description="A Ballot file has already be uploaded for this chart. Would you like to use this file or upload a new one?"
        acceptText="Use Current File"
        rejectText="Upload a New File"
        toggle={() => {}}
        onSave={(value) =>
          value ? state.useExistingBallotFile() : state.uploadNewBallotFile()
        }
      />
    </>
  )
}

export default AdminManageGeneralChartForm
